import { Campaign, CampaignServiceVariant } from '@markant-platform/campaign/model';
import { Industry } from 'data-model';
import { Price } from '@markant-platform/cartridge/model';

export const MOCK_SERVICE_VARIANT_FOR_CAMPAIGN: CampaignServiceVariant = {
  cartridgeId: 'id',
  cartridgeVariantId: 'variantId',
  variantName: 'name',
  cartridgeName: 'cartridge',
  cartridgeDescription: 'description',
  variantDescription: 'variant description',
  isDemo: true,
  price: {
    currency: 'EUR',
    centAmount: 2000.0,
    priceModel: 'SUBSCRIPTION',
    billingPeriod: 'MONTHLY',
  } as Price,
};
export const MOCK_CAMPAIGN: Campaign = {
  campaignId: 'campaignId',
  campaignName: 'campaignName',
  industry: Industry.SUPPLIER,
  requiredFields: {
    gln: false,
    industry: true,
    organizationPhone: true,
    billingLanguage: true,
    billingEmail: true,
  },
  serviceVariants: [MOCK_SERVICE_VARIANT_FOR_CAMPAIGN],
};
